import dayjs from "dayjs";

export class DateFormat {
  static dateRendering = (
    dateVal: Array<Record<string, unknown>>,
    key: "from" | "to"
  ) => {
    switch (key) {
      case "from":
        return dayjs(dateVal![0]?.$d as Date)
          .startOf("day")
          .format("YYYY-MM-DD");
      case "to":
        return dayjs(dateVal![1]?.$d as Date).format("YYYY-MM-DD");
    }
  };

  static getDateRange = (dateRange: number = 0) => {
    return {
      fromDate: dayjs()
        .subtract(dateRange, "day")
        .startOf("day")
        .format("YYYY-MM-DD"),
      toDate: dayjs().format("YYYY-MM-DD"),
    };
  };

  static convertToISO = (dateStr: { $y: number; $M: number; $D: number }) => {
    const year = dateStr.$y;
    const month = dateStr.$M + 1;
    const day = dateStr.$D;
    const isoDate = `${year.toString().padStart(4, "0")}-${month
      .toString()
      .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;
    return isoDate;
  };
}

export const { convertToISO, dateRendering, getDateRange } = DateFormat;
